/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

export default {
  root (state) {
    return state.list
  },
  showProducts (state) {
    return !(state.metaData.display_mode && state.metaData.display_mode === 'PAGE')
  },
  showBlock (state) {
    return state.metaData && state.metaData.cms_block ? state.metaData.cms_block.identifier : null
  },
  breadcrumbs (state) {
    return state.metaData.breadcrumbs || []
  },
  getUrlKeyCurrentCat (state) {
    return state.current && state.current.url_path ? state.current.url_path : null
  }
}
